import { render, staticRenderFns } from "./PhoneHome.vue?vue&type=template&id=55eca4d8&scoped=true"
import script from "./PhoneHome.vue?vue&type=script&lang=js"
export * from "./PhoneHome.vue?vue&type=script&lang=js"
import style0 from "./PhoneHome.vue?vue&type=style&index=0&id=55eca4d8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55eca4d8",
  null
  
)

export default component.exports